import { useState } from "react";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import PrimaryNav from "@/components/PrimaryNav";

const COLLAPSE_KEY = "sidenav-collapsed";

/**
 * The desktop rail.
 *
 * The nav itself — the entries, their order, the department cascade, Settings
 * at the floor — lives in PrimaryNav, because the mobile drawer renders the
 * very same component. What is left here is what only a permanently-visible
 * rail has: the width, the navy plane it is painted on, and the collapse
 * toggle that owns it.
 */
const SideNav = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSE_KEY) === "1");

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      localStorage.setItem(COLLAPSE_KEY, prev ? "0" : "1");
      return !prev;
    });
  };

  return (
    <aside
      className={cn(
        "hidden flex-shrink-0 flex-col overflow-hidden bg-gradient-to-b from-sidebar to-[hsl(var(--sidebar-background-deep))] transition-[width] duration-200 lg:flex",
        collapsed ? "w-14" : "w-60",
      )}
    >
      <PrimaryNav
        collapsed={collapsed}
        footerSlot={
          <div className={cn("flex", collapsed ? "justify-center" : "justify-end")}>
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleCollapsed}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              // 60% of the sidebar text token was 3.8:1 on the navy — the one
              // control in the rail that missed AA, and a chevron has no word
              // beside it to be read instead. 75% keeps it a step quieter than
              // a nav label (85%) while clearing the line at 5.8:1 / 6.3:1.
              className="h-7 w-7 rounded-md text-sidebar-foreground/75 hover:bg-white/10 hover:text-white"
            >
              {collapsed ? <ChevronsRight className="h-4 w-4" /> : <ChevronsLeft className="h-4 w-4" />}
            </Button>
          </div>
        }
      />
    </aside>
  );
};

export default SideNav;
